import { getAdjustedTime, DATE_FORMATS } from '@/lib/timeUtils'

export function formatScheduledTime(
	utcString: string,
	locale?: string,
	todayLabel = 'Today',
	timeZoneOffset?: number,
	tomorrowLabel = 'Tomorrow',
	atSeparator = 'at',
): string {
	const raw = new Date(utcString)
	if (isNaN(raw.getTime())) return utcString

	const date = timeZoneOffset !== undefined ? getAdjustedTime(timeZoneOffset, raw) : raw
	const now = timeZoneOffset !== undefined ? getAdjustedTime(timeZoneOffset) : new Date()

	const isSameCalendarDay = (a: Date, b: Date) =>
		a.getFullYear() === b.getFullYear() &&
		a.getMonth() === b.getMonth() &&
		a.getDate() === b.getDate()

	const tomorrow = new Date(now)
	tomorrow.setDate(tomorrow.getDate() + 1)

	const effectiveLocale = locale ?? 'en-US'
	const formatOptions = DATE_FORMATS[effectiveLocale] ?? DATE_FORMATS.defaultFormat
	const timeStr = date.toLocaleTimeString(effectiveLocale, formatOptions)
	const dateStr = date.toLocaleDateString(effectiveLocale, {
		weekday: 'long',
		month: 'numeric',
		day: 'numeric',
	})

	if (isSameCalendarDay(date, now)) return `${todayLabel} ${atSeparator} ${timeStr}`
	if (isSameCalendarDay(date, tomorrow)) return `${tomorrowLabel} ${atSeparator} ${timeStr}`
	return `${dateStr} ${atSeparator} ${timeStr}`
}
